
import { User } from "@/interfaces/Landing";
import { Auth, FoodicsAuth } from "@/services/core";
import { Concept as ConceptApi, Menu, SettingsConcepts } from "@/services/SOLO";
import { ValidationObserver, configure } from "vee-validate";
import { mapGetters, mapMutations } from "vuex";
import { eventHandler, translations } from "@/mixins";
import WelcomeModal from "./components/WelcomeModal.vue";
import PermissionModal from "./components/PermissionModal.vue";
import {
  Component,
  Prop,
  Vue,
  Watch,
  Ref,
  Mixins,
} from "vue-property-decorator";
import authService from "@/services/core/auth.service";
import { Subscription } from "@/services/SOLO";
import { Concept } from "@/models";
import store from "@/store";
import moment from "moment";
import EnvironmentSwitcher from "@/components/V2/EnvironmentSwitcher.vue";

@Component({
  components: { WelcomeModal, PermissionModal, EnvironmentSwitcher },
  computed: {
    ...mapGetters({
      getUser: "account/getUser",
      getUserRole: "account/getUserRole",
      isLoggedIn: "account/isLoggedIn",
      activeConcept: "account/activeConcept",
      activeLanguage: "account/activeLanguage",
      getUserClient: "account/getUserClient",
      getConceptSettings: "account/getConceptSettings",
    }),
    isDev() {
      return ["development", "staging"].indexOf(process.env.VUE_APP_ENV) !== -1;
    },
  },
  methods: {
    ...mapMutations({
      setUser: "account/setUser",
      setUser2: "account/setUser2",
      setUserRole: "account/setUserRole",
      setSubscription: "account/setSubscription",
      setConceptSettings: "account/setConceptSettings",
      setUserConcept: "account/setUserConcept",
      setUserLanguage: "account/setUserLanguage",
      setMenus: "menu/setMenus",
      setQRUri: "tfa/setQRUri",
      setSecretKey: "tfa/setSecretKey",
      setTfaToken: "tfa/setTfaToken",
    }),
  },
  mixins: [eventHandler, translations],
})
export default class Home extends Vue {
  private getUserClient: any;
  activeConcept!: Concept;
  activeLanguage!: Concept;
  translate: any;
  activateScript: any = false;
  setUser!: Function;
  setUser2!: Function;
  setUserRole!: Function;
  setMenus!: Function;
  setQRUri!: Function;
  setSecretKey!: Function;
  setTfaToken!: Function;
  getUser!: typeof mapGetters;
  getUserRole!: typeof mapGetters;
  getConceptSettings!: any;
  isDev!: boolean;
  notify: boolean = false;
  model: User = {
    username: "",
    password: "",
    rememberMe: false,
  };
  $refs!: {
    formValidator: InstanceType<typeof ValidationObserver>;
    welcomeModal: WelcomeModal;
    permissionModal: PermissionModal;
  };
  waiting!: Function;
  restore!: Function;
  setSubscription!: Function;
  setConceptSettings!: Function;
  setUserConcept!: Function;
  setUserLanguage!: Function;
  isLoggedIn!: Function;
  errLogin: string = "";
  loaded: boolean = false;
  clientLabel: string = "";
  constructor() {
    super();
  }

  mounted() {
    if (this.isLoggedIn) {
      this.$router.push({ name: "dashboard" });
    }
    if (this.getClientUserLabel === "Foodics Online") {
      this.activateScript = true;
    }

    this.loaded = true;
  }

  public get logo(): string {
    if (this.getUserClient) {
      return this.getUserClient.attributes["logo-uri"];
    }
    return ``;
  }

  public get getClientUserLabel() {
    return this.getUserClient?.attributes?.label;
  }

  public get hasFoodicsRegister(): Boolean {
    if (this.getUserClient) {
      if (this.getUserClient.attributes.auth.split(",").includes("foodics")) {
        return true;
      }
      return false;
    }
    return false;
  }

  private get hasSoloRegister(): Boolean {
    if (this.getUserClient) {
      if (
        this.getUserClient.attributes.auth.split(",").includes("solo-register")
      ) {
        return true;
      }
      return false;
    }
    return false;
  }

  async created() {
    if (window.location.host.includes("foodics")) {
      this.clientLabel = "Foodics Online";
    }

    let code: string = this.$route.query.code as string;
    if (code) {
      try {
        let response = await FoodicsAuth.getToken(code);
      } catch (error) {
        console.error("Error:", error);
        this.$refs.welcomeModal.notify = true;
        this.$refs.welcomeModal.success = false;
      }
    }
  }

  async authenticate(e: any) {
    this.errLogin = "";
    const defaultText = e.target.innerHTML;
    this.waiting(e, '<i class="fas fa-spinner fa-spin"></i> Signing in');
    Auth.login(this.model)
      .then(async (response: any) => {
        await this.setUserConcept(response.data.data.attributes.concepts[0]);
        await this.setUser(response.data.data);
        await this.setUser2(response.data.data);
        await this.setUserRole(response.data.data.attributes.roles);
        let concept: any;
        await SettingsConcepts.get()
          .then(async (response: any) => {
            concept = response.data.data;
          })
          .catch((err: any) => {
            console.log(err);
          });

        if (concept.attributes["is-2fa-enabled"]) {
          if (!response.data.data["attributes"]["tfa-factors"].length) {
            // delete user object temporarily to proceed with 2FA setup
            // restricts from accessing dashboard
            this.setUser(null);

            this.$router.push({ name: "account-protected" });
            // }).catch((err: any) => {
            //   console.log(err)
            //   this.errLogin = err.response.data.error[0].detail
            // })
          }
        } else {
          this.getSubscriptionFn(
            response.data.data,
            response.data.data.attributes.roles
          );
          this.getConcepts();
        }
        this.restore(e, defaultText);

        // this.setUserConcept(response.data.data.attributes.concepts[0])
        // this.setUser(response.data.data)
        // this.setUserRole(response.data.data.attributes.roles)
        // await SettingsConcepts.get().then(async (response: any) => {
        //   await this.setConceptSettings(response.data.data)
        // }).catch((err: any) => {
        //   console.log(err)
        // })
        // if (this.getConceptSettings.attributes['is-2fa-enabled']) {
        //   // if (response.data.data.attributes['tfa-factors'].length) {
        //   //   this.$router.push({ name: 'code-verifier' })
        //   // } else {
        //     this.$router.push({ name: 'account-protected' })
        //   // }
        // } else {
        //   this.getSubscriptionFn(response.data.data, response.data.data.attributes.roles)
        //   this.getConcepts()
        // }
        // this.restore(e, defaultText)
      })
      .catch((err: any) => {
        console.log(err.response.data);
        if (err.response.data.error[0].code == 2403) {
          // this.setUserConcept({})
          // this.setUser(null)
          // this.setUserRole([])
          this.setTfaToken(err.response.data.messages[0]["tfa-token"]);
          this.$router.push({ name: "code-verifier" });
        }

        this.restore(e, defaultText);
        this.errLogin = err.response.data.error[0].detail;
      });
  }

  async getConcepts() {
    SettingsConcepts.get()
      .then((response: any) => {
        this.getLanguages(response.data.data);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  private getLanguages(data: any) {
    this.setUserLanguage(data.attributes.languages[1]);
  }

  getApps() {
    Menu.all()
      .then((response: any) => {
        this.setMenus(response.data.data);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  private getAccountConcept(data: any, roles: any, subscription: any) {
    ConceptApi.get().then((response) => {
      console.log(response.data.data);
      this.setConceptSettings(response.data.data);
      this.setSubscription(subscription);
      this.getApps();
      this.$router.push({ name: "dashboard" });
    });
  }

  private getSubscriptionFn(data: any, roles: any) {
    this.setUserConcept(data.attributes.concepts[0]);
    this.setUser(data);
    this.setUserRole(roles);
    Subscription.getSubscription()
      .then((response) => {
        this.getAccountConcept(data, roles, response.data.data);
      })
      .catch((err) => {
        this.getAccountConcept(data, roles, null);
      });
  }

  signInWithFoodics() {
    FoodicsAuth.redirect();
  }
}
